import React from 'react';
export function Footer() {
  return <footer className="w-full bg-cream px-4 pb-28 pt-12 sm:px-6 sm:pb-24" data-id="element-134" data-mp="32wd2qgad7ltj">
      <div className="mx-auto max-w-2xl text-center" data-id="element-135" data-mp="3ggapns7ja73v">
        <div className="inline-flex items-center gap-2" data-id="element-136" data-mp="32nul2myzi10u">
          <span className="flex h-9 w-9 items-center justify-center rounded-lg bg-brand-500 font-display text-lg font-bold text-white" data-id="element-137" data-mp="32pffmclatjyp">
            K
          </span>
          <span className="font-display text-lg font-bold tracking-tight text-ink" data-id="element-138" data-mp="3ueih5klswg7n">
            Dott.ssa <span className="text-brand-500" data-id="element-139" data-mp="398zqhbvha9n">Karito</span>
          </span>
        </div>
        <p className="mx-auto mt-5 max-w-lg text-[12px] font-medium leading-relaxed text-inksoft" data-id="element-140" data-mp="3lem127dh8po7">
          Kit Clinico per la Gestione dell’Obesità. Materiale educativo destinato ai professionisti
          sanitari. Non sostituisce il giudizio clinico, le informazioni ufficiali sui farmaci o le
          linee guida locali.
        </p>
        <p className="mt-5 text-[12px] font-semibold text-inksoft" data-id="element-141" data-mp="2ez1iw8rrqwxs">
          © 2026 Dott.ssa Karito. Tutti i diritti riservati.
        </p>
      </div>
    </footer>;
}